import {
  Card,
  BlockStack,
  Text,
  Tabs,
  DataTable,
} from '@shopify/polaris';
import React, { useEffect, useState } from 'react';
import { DIProps, DI } from '../../../../../../Core';

interface props extends DIProps {
  FullOrderData: any
}

const NewArchievedOrderItemTable = (props: props) => {
  const { FullOrderData } = props;
  const [rows, setrows] = useState([]);
  const [total, settotalPrice] = useState('');
  useEffect(() => {
    let dataTemp: any = []
    let totalPrice = '0'
    FullOrderData?.items?.map((data: any) => {
      dataTemp.push([
        <Text variant="bodySm" breakWord as="span">{data?.title || "N/A"}</Text>,
        <Text variant="bodySm" as="span">{data?.sku || "N/A"}</Text>,
        <Text variant="bodySm" as="span">{data?.qty || "N/A"}</Text>,
        <Text variant="bodySm" as="span">{data?.marketplace_price || "N/A"}</Text>
      ])
      totalPrice = +(totalPrice) + data?.marketplace_price
    })
    setrows(dataTemp)
    settotalPrice(totalPrice)
  }, [FullOrderData])



  // const rows = [
  //   [
  //     <Text variant="bodySm" breakWord as="span">Example Product Title 1</Text>,
  //     <Text variant="bodySm" as="span">ABC123</Text>,
  //     <Text variant="bodySm" as="span">2</Text>,
  //     <Text variant="bodySm" as="span">$19.99</Text>
  //   ],
  //   [
  //     <Text variant="bodySm" breakWord as="span">Example Product Title 1</Text>,
  //     <Text variant="bodySm" as="span">ABC123</Text>,
  //     <Text variant="bodySm" as="span">2</Text>,
  //     <Text variant="bodySm" as="span">$19.99</Text>
  //   ],
  //   [
  //     <Text variant="bodySm" breakWord as="span">Example Product Title 1</Text>,
  //     <Text variant="bodySm" as="span">ABC123</Text>,
  //     <Text variant="bodySm" as="span">2</Text>,
  //     <Text variant="bodySm" as="span">$19.99</Text>
  //   ],
  // ];

  return (
    <Card roundedAbove="sm">
      <BlockStack gap={{ xs: '050', sm: '100', md: '300', lg: '300', xl: '300' }}>
        <Text variant="headingMd" as="h6">
          Archieved Order Details
        </Text>
        <BlockStack gap={{ xs: '050', sm: '200', md: '400', lg: '400', xl: '400' }}>
          <div className='custom-remove-tab-padding'>
            <Tabs tabs={[
              {
                id: 'amazon',
                content: 'Amazon',
              }
            ]} selected={0} />
          </div>
          <Card padding="0" roundedAbove="sm">
            <div className="Custom__Data--Table">
              <DataTable
                showTotalsInFooter
                columnContentTypes={['text', 'text', 'numeric', 'numeric']}
                headings={[<Text as='p' variant='bodyLg' fontWeight='medium'>Title</Text>,
                <Text as='p' variant='bodyLg' fontWeight='medium'>SKU</Text>,
                <Text as='p' variant='bodyLg' fontWeight='medium'>Qty</Text>,
                <Text as='p' variant='bodyLg' fontWeight='medium'>Price</Text>]}
                rows={rows}
                totals={['', '', '', `$${(total)}`]}
                totalsName={{
                  singular: 'Total (paid by customer)',
                  plural: 'Total (paid by customer)',
                }}
              />
            </div>
          </Card>
        </BlockStack>
      </BlockStack>
    </Card>
  );
};

export default DI(NewArchievedOrderItemTable);
